import { classNames } from '@/shared/lib/classNames';
import { getSizeClassName } from '../model/utils';
import { SegmentsProps, TSegmentItem } from '../model/types';
import cls from './SegmentItem.module.scss';

type Props = { isActive: boolean; size: SegmentsProps['size']; onClick: (value: string) => void } & TSegmentItem;

export const SegmentItem = ({ isActive, onClick, label, size = 'xl', value }: Props) => {
    const sizeClassName = getSizeClassName(size, cls);

    return (
        <button
            className={classNames(cls.container, { [cls.active]: isActive }, [sizeClassName])}
            type="button"
            onClick={() => onClick(value)}
        >
            <p>{label}</p>
        </button>
    );
};
